// extracted by mini-css-extract-plugin
export default {"arrowButton":"NegotiationCell_arrowButton__7nnGJ","expanded":"NegotiationCell_expanded__+Ozh7","icon":"NegotiationCell_icon__77efH"};